import { createSlice } from 'utils/@reduxjs/toolkit';
import { ModalState } from './types';
import { reducers } from './reducers';

export const initialState: ModalState = {
  data: {
    show: false,
    content: null,
  },
};

const slice = createSlice({
  name: 'modal',
  initialState,
  reducers,
});

export const { actions: modalActions } = slice;
export const { reducer: modalReducer } = slice;
